
export function filterDuplicate(arrObj, prop) {
  return arrObj.filter((obj, pos, arr) => arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos);
}

export default {
  filterDuplicate,
};
